import React, { useState, useEffect } from 'react';
import Layout4 from "hocs/Layouts/Layout4";
import axios from 'axios';

function ReportNodo() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const [projects, setProjects] = useState([]);
    const [selectedProject, setSelectedProject] = useState('');

    const [municipalities, setMunicipalities] = useState([]);
    const [selectedMunicipality, setSelectedMunicipality] = useState('');

    // 🔹 Nuevos estados
    const [tipoAplicacion, setTipoAplicacion] = useState('');
    const [terceroEntrada, setTerceroEntrada] = useState('');
    const [quintoEntrada, setQuintoEntrada] = useState('');

    // Obtener proyectos
    const fetchProjects = async () => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/auth/proyecto/`
            );
            setProjects(response.data);
        } catch {
            setError("Hubo un error al obtener los proyectos");
        }
    };

    // Obtener municipios según proyecto
    const fetchMunicipalities = async (projectName) => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/res/municipios/?proyecto_id=${projectName}`
            );
            setMunicipalities(response.data);
        } catch {
            setError("Hubo un error al obtener los municipios");
        }
    };

    useEffect(() => {
        fetchProjects();
    }, []);

    useEffect(() => {
        if (selectedProject) {
            fetchMunicipalities(selectedProject);
            setSelectedMunicipality('');
        }
    }, [selectedProject]);

    // 🔥 Generar reporte real
    const fetchData = async () => {
        if (!selectedProject || !selectedMunicipality || !tipoAplicacion) {
            setError("Por favor selecciona proyecto, ciudad y aplicación");
            return;
        }

        try {
            setLoading(true);
            setError(null);

            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/res/pdf3/`,
                {
                    params: {
                        proyecto: selectedProject,
                        ciudad: selectedMunicipality,
                        aplicacion: tipoAplicacion,
                        matriculados_tercero: terceroEntrada,
                        matriculados_quinto: quintoEntrada,
                    },
                    responseType: 'blob',
                }
            );

            // Descargar PDF automáticamente
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `reporte_${selectedMunicipality}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();

        } catch {
            setError("Error generando el reporte");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Layout4>
            <div style={styles.container}>
                <h1 style={styles.title}>Generador de Reportes Nodo.</h1>

                {/* Proyecto */}
                <div style={styles.selectContainer}>
                    <label style={styles.selectLabel}>Selecciona un Proyecto</label>
                    <select
                        value={selectedProject}
                        onChange={(e) => setSelectedProject(e.target.value)}
                        style={styles.select}
                    >
                        <option value="">-- Selecciona un proyecto --</option>
                        {projects.map((project) => (
                            <option key={project.id} value={project.nombre}>
                                {project.nombre}
                            </option>
                        ))}
                    </select>
                </div>

                {/* Municipio */}
                {selectedProject && (
                    <div style={styles.selectContainer}>
                        <label style={styles.selectLabel}>Selecciona una Ciudad</label>
                        <select
                            value={selectedMunicipality}
                            onChange={(e) => setSelectedMunicipality(e.target.value)}
                            style={styles.select}
                        >
                            <option value="">-- Selecciona una ciudad --</option>
                            {municipalities.map((municipio, index) => (
                                <option key={index} value={municipio}>
                                    {municipio}
                                </option>
                            ))}
                        </select>
                    </div>
                )}

                {/* Tipo Aplicación */}
                {selectedMunicipality && (
                    <div style={styles.selectContainer}>
                        <label style={styles.selectLabel}>Tipo de Aplicación</label>
                        <select
                            value={tipoAplicacion}
                            onChange={(e) => setTipoAplicacion(e.target.value)}
                            style={styles.select}
                        >
                            <option value="">-- Selecciona --</option>
                            <option value="entrada">Entrada</option>
                            <option value="salida">Salida</option>
                        </select>
                    </div>
                )}

                {/* Matriculados */}
                {tipoAplicacion && (
                    <div style={styles.selectContainer}>
                        <label style={styles.selectLabel}>Matriculados Tercero</label>
                        <input
                            type="number"
                            value={terceroEntrada}
                            onChange={(e) => setTerceroEntrada(e.target.value)}
                            style={styles.select}
                        />

                        <label style={styles.selectLabel}>Matriculados Quinto</label>
                        <input
                            type="number"
                            value={quintoEntrada}
                            onChange={(e) => setQuintoEntrada(e.target.value)}
                            style={styles.select}
                        />
                    </div>
                )}

                <button
                    onClick={fetchData}
                    disabled={loading}
                    style={styles.button}
                >
                    {loading ? "Generando reporte..." : "Obtener Reporte"}
                </button>

                {error && <p style={styles.errorText}>{error}</p>}
            </div>
        </Layout4>
    );
}

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '90vh',
        backgroundColor: '#F8F8F8',
        padding: '20px',
    },
    title: {
        color: '#1B8830',
        fontSize: '2rem',
        marginBottom: '20px',
    },
    selectContainer: {
        marginBottom: '20px',
        display: 'flex',
        flexDirection: 'column',
        width: '300px',
    },
    selectLabel: {
        color: '#1B8830',
        marginBottom: '5px',
    },
    select: {
        padding: '10px',
        border: '1px solid #ccc',
        borderRadius: '5px',
    },
    button: {
        backgroundColor: '#1B8830',
        color: 'white',
        border: 'none',
        padding: '10px 20px',
        cursor: 'pointer',
        borderRadius: '5px',
    },
    errorText: {
        color: 'red',
        marginTop: '10px',
    },
};

export default ReportNodo;
